module.exports = __webpack_public_path__ + "img/warnings-06.ac82af11.png";